import { useSelector } from 'react-redux'
import { Grid } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import TestDetailCard from '../components/TestDetailCard';


const TestDetialPage = (uuid) => {
    const customization = useSelector((state) => state.customization);

    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "40px"}}>
            <Grid item xs={12} >
                    {customization.login && (<TestDetailCard uuid={uuid}/>)}
            </Grid>
        </Grid>
    );
};

export default TestDetialPage;
